// 自定义列信息
export const customColumns = [
  {
    key: 'aggregation_info',
    type: 'dimension',
    children: [
      {
        key: 'budget_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'sale_type',
        type: 'dimension',
        isSelected: true,
      }
    ],
  },
  {
    key: 'product_info',
    type: 'dimension',
    children: [
      // {
      //   key: 'product',
      //   isSelected: true,
      // },
      {
        key: 'product_id',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'product_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'product_series_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'new_series_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'customer_cate',
        type: 'dimension',
        isSelected: true,
      },
      // {
      //   key: 'weight',
      //   isSelected: false,
      // },
    ],
  },

  {
    key: 'task_info',
    type: 'dimension',
    children: [
      {
        key: 'task_name',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'sale_info',
    type: 'dimension',
    children: [
      // {
      //   key: 'direct_sale2',
      //   isSelected: false,
      // },
      // {
      //   key: 'sale',
      //   isSelected: false,
      // },
      // 20260701
      // {
      //   key: 'direct_sales_id',
      //   isSelected: false,
      // },
      {
        key: 'direct_sales_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'sale_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'sale_name',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'agent_adv',
    type: 'dimension',
    children: [
      // {
      //   key: 'agent',
      //   isSelected: false,
      // },
      {
        key: 'agent_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'agent_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'agent_company',
        type: 'dimension',
        isSelected: false,
      },

      // {
      //   key: 'account',
      //   isSelected: false,
      // },
      {
        key: 'user_sub_agent_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'user_sub_agent_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_company',
        type: 'dimension',
        isSelected: false,
      },

      // {
      //   key: 'category',
      //   isSelected: false,
      // },

      {
        key: 'category_one',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'category_two',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'category_three',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'plan_action_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'app_marketing_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'idea_type',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'is_rta',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'bid',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'charge_type',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'impression_click_cost',
    type: 'metric',
    children: [
      // {
      //   key: 'served_request',
      //   isSelected: true,
      //   isHover: true,
      // },
      {
        key: 'impression_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'click_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_cash',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_coupon',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      // {
      //   key: 'weight_cost',
      //   isSelected: false,
      // },
      // {
      //   key: 'sale_weight',
      //   isSelected: false,
      // },
    ],
  },

  // {
  //   key: 'owners_info',
  //   children: [
  //     {
  //       key: 'owner_names',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'weight_cost',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'weight_cash_cost',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'weight_coupon_cost',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'sale_weight',
  //       isSelected: false,
  //     },
  //   ],
  // },

  {
    key: 'good_effect',
    type: 'metric',
    children: [
      {
        key: 'cr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'acp',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'list_ctr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'detail_ctr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'list_acp',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'detail_acp',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'list_ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'detail_ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cpa_given',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cvr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'deep_cvr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cpa',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'deep_cpa',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_active_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_register_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_lahuo_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cvr_keyaction_num',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_keyaction_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_pay_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_active_rate',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_register_rate',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_lahuo_rate',
        type: 'metric',
        isSelected: false,
      },
    ],
  },

  {
    key: 'plans_and_ideas',
    type: 'metric',
    children: [
      {
        key: 'put_plans_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'put_ideas_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'new_ideas_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      // {
      //   key: 'idea_type',
      //   isSelected: false
      // },
      // {
      //   key: 'unit',
      //   isSelected: false
      // },
      // {
      //   key: 'is_ocpc',
      //   isSelected: false
      // }
    ],
  },
];

// 自定义列信息
export const customColumns2 = [
  {
    key: 'aggregation_info',
    type: 'dimension',
    children: [
      {
        key: 'budget_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'sale_type',
        type: 'dimension',
        isSelected: true,
      }
    ],
  },
  {
    key: 'product_info',
    type: 'dimension',
    children: [
      // {
      //   key: 'product',
      //   isSelected: true,
      // },
      {
        key: 'product_id',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'product_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'product_series_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'new_series_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'customer_cate',
        type: 'dimension',
        isSelected: true,
      },
    ],
  },

  {
    key: 'task_info',
    type: 'dimension',
    children: [
      {
        key: 'task_name',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'sale_info',
    type: 'dimension',
    children: [
      // {
      //   key: 'direct_sale2',
      //   isSelected: false,
      // },
      // {
      //   key: 'sale',
      //   isSelected: false,
      // },
      // 20260701
      // {
      //   key: 'direct_sales_id',
      //   isSelected: false,
      // },
      {
        key: 'direct_sales_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'sale_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'sale_name',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'agent_adv',
    type: 'dimension',
    children: [
      // {
      //   key: 'agent',
      //   isSelected: false,
      // },
      {
        key: 'agent_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'agent_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'agent_company',
        type: 'dimension',
        isSelected: false,
      },

      // {
      //   key: 'account',
      //   isSelected: false,
      // },
      {
        key: 'user_sub_agent_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'user_sub_agent_name',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'account_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_company',
        type: 'dimension',
        isSelected: false,
      },

      // {
      //   key: 'category',
      //   isSelected: false,
      // },

      {
        key: 'category_one',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'category_two',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'category_three',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'plan_action_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'app_marketing_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'idea_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'is_rta',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'bid',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'charge_type',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'impression_click_cost',
    type: 'metric',
    children: [
      // {
      //   key: 'served_request',
      //   isSelected: true,
      //   isHover: true,
      // },
      {
        key: 'impression_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'click_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_cash',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_coupon',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
    ],
  },

  {
    key: 'good_effect',
    type: 'metric',
    children: [
      {
        key: 'cr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'acp',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'list_ctr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'detail_ctr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'list_acp',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'detail_acp',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'list_ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'detail_ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cpa_given',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cvr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'deep_cvr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cpa',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'deep_cpa',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_active_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_register_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_lahuo_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cvr_keyaction_num',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_keyaction_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_pay_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_active_rate',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_register_rate',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_lahuo_rate',
        type: 'metric',
        isSelected: false,
      },
    ],
  },

  {
    key: 'plans_and_ideas',
    type: 'metric',
    children: [
      {
        key: 'put_plans_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'put_ideas_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'new_ideas_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      // {
      //   key: 'idea_type',
      //   isSelected: false
      // },
      // {
      //   key: 'unit',
      //   isSelected: false
      // },
      // {
      //   key: 'is_ocpc',
      //   isSelected: false
      // }
    ],
  },
];

// 自定义列信息
export const customColumns3 = [
  {
    key: 'aggregation_info',
    type: 'dimension',
    children: [
      {
        key: 'budget_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'sale_type',
        type: 'dimension',
        isSelected: true,
      }
    ],
  },
  {
    key: 'product_info',
    type: 'dimension',
    children: [
      // {
      //   key: 'product',
      //   isSelected: true,
      // },
      {
        key: 'product_id',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'product_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'product_series_name',
        type: 'dimension',
        isSelected: true,
      },
      {
        key: 'customer_cate',
        type: 'dimension',
        isSelected: true,
      },
      // {
      //   key: 'weight',
      //   isSelected: false,
      // },
    ],
  },

  {
    key: 'task_info',
    type: 'dimension',
    children: [
      {
        key: 'task_name',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'sale_info',
    type: 'dimension',
    children: [
      // {
      //   key: 'direct_sale2',
      //   isSelected: false,
      // },
      // {
      //   key: 'sale',
      //   isSelected: false,
      // },
      // 20260701
      // {
      //   key: 'direct_sales_id',
      //   isSelected: false,
      // },
      {
        key: 'direct_sales_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'sale_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'sale_name',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'agent_adv',
    type: 'dimension',
    children: [
      // {
      //   key: 'agent',
      //   isSelected: false,
      // },
      {
        key: 'agent_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'agent_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'agent_company',
        type: 'dimension',
        isSelected: false,
      },

      // {
      //   key: 'account',
      //   isSelected: false,
      // },
      {
        key: 'user_sub_agent_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'user_sub_agent_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_id',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_name',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'account_company',
        type: 'dimension',
        isSelected: false,
      },

      // {
      //   key: 'category',
      //   isSelected: false,
      // },

      {
        key: 'category_one',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'category_two',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'category_three',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'plan_action_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'app_marketing_type',
        type: 'dimension',
        isSelected: false,
      },

      {
        key: 'idea_type',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'is_rta',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'bid',
        type: 'dimension',
        isSelected: false,
      },
      {
        key: 'charge_type',
        type: 'dimension',
        isSelected: false,
      },
    ],
  },

  {
    key: 'impression_click_cost',
    type: 'metric',
    children: [
      // {
      //   key: 'served_request',
      //   isSelected: true,
      //   isHover: true,
      // },
      {
        key: 'impression_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'click_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_total',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_cash',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_coupon',
        type: 'metric',
        isSelected: true,
        isHover: true,
      },
      // {
      //   key: 'weight_cost',
      //   isSelected: false,
      // },
      // {
      //   key: 'sale_weight',
      //   isSelected: false,
      // },
    ],
  },

  // {
  //   key: 'owners_info',
  //   children: [
  //     {
  //       key: 'owner_names',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'weight_cost',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'weight_cash_cost',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'weight_coupon_cost',
  //       isSelected: false,
  //     },
  //     {
  //       key: 'sale_weight',
  //       isSelected: false,
  //     },
  //   ],
  // },

  {
    key: 'good_effect',
    type: 'metric',
    children: [
      {
        key: 'cr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'acp',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'list_ctr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'detail_ctr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'list_acp',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'detail_acp',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'list_ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'detail_ecpm',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cpa_given',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cvr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'deep_cvr',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cpa',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'deep_cpa',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_active_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_register_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_lahuo_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'cvr_keyaction_num',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_keyaction_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_pay_cost',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_active_rate',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_register_rate',
        type: 'metric',
        isSelected: false,
      },
      {
        key: 'api_app_retention_lahuo_rate',
        type: 'metric',
        isSelected: false,
      },
    ],
  },

  {
    key: 'plans_and_ideas',
    type: 'metric',
    children: [
      {
        key: 'put_plans_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'put_ideas_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'new_ideas_num',
        type: 'metric',
        isSelected: false,
        isHover: true,
      },
      // {
      //   key: 'idea_type',
      //   isSelected: false
      // },
      // {
      //   key: 'unit',
      //   isSelected: false
      // },
      // {
      //   key: 'is_ocpc',
      //   isSelected: false
      // }
    ],
  },
];

// // 固定显示的表格列
// export const fixedColumns = [
//   {
//     key: 'base_info2',
//     children: [
//       {
//         key: 'date',
//       },
//       // {
//       //   key: 'budget_name',
//       // },
//       // {
//       //   key: 'sale_type',
//       // }
//     ],
//   },
// ];

// 固定显示的表格列
export const fixedColumns = [
  {
    key: 'date',
  },
];


// 折线图指标
export const fields = [
  // 'served_request',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_cash',
  'cost_coupon',
];

// 包含涨幅数据的字段
export const fieldWithDiff = [
  // 'served_request',
  'cost_cash',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_coupon',
  'acp',
  'ecpm',
  'list_acp',
  'detail_acp',
  'list_ecpm',
  'detail_ecpm',
  'cpa_given',
  'put_ideas_num',
  'put_plans_num',
  // 'new_ideas_num',
  'cvr',
  'deep_cvr',
  'cpa',
  'deep_cpa',
  'api_app_active_cost',
  'api_app_register_cost',
  'api_app_lahuo_cost',
  'cvr_keyaction_num',
  'api_app_keyaction_cost',
  'api_app_pay_cost',
  'api_app_retention_active_rate',
  'api_app_retention_register_rate',
  'api_app_retention_lahuo_rate',
];
